import { SearchMdIcon } from '@prophecy/icons';
import { theme } from '@prophecy/theme';
import { Button, Checkbox, Ellipsis, Input, MultiSelect, Select, Stack } from '@prophecy/ui-v3';
import styled from 'styled-components';
import { Updater } from 'use-immer';

import { FilterType, initialFilter, TemplateType } from '../types';

const SearchInput = styled(Input)`
  width: 288px;
`;

export const TemplateFilter = ({
  filter,
  setFilter,
  teamNames,
  templates: _templates
}: {
  filter: FilterType;
  setFilter: Updater<FilterType>;
  teamNames: string[];
  templates: TemplateType[];
}) => {
  return (
    <Stack gap={theme.spaces.x32}>
      <Stack direction='horizontal' gap={theme.spaces.x32} alignY='end'>
        <SearchInput
          label='Search'
          icon={<SearchMdIcon type='default'></SearchMdIcon>}
          placeholder={'Search for templates'}
          value={filter.query}
          onChange={(value) =>
            setFilter((draft) => {
              draft.query = value;
            })
          }
          data-test-id='template-filter-search-input'></SearchInput>
        <Stack direction='horizontal' gap={theme.spaces.x8} alignY='end'>
          <MultiSelect
            label={'Team'}
            value={filter.teams}
            options={teamNames}
            virtual={false}
            dropdownMatchSelectWidth={false}
            data-test-id='template-filter-team-select'
            renderOption={(item) => (
              <Select.Option value={item}>
                <Stack
                  width='200px'
                  gap={theme.spaces.x6}
                  alignY='center'
                  direction='horizontal'
                  padding={`${theme.spaces.x4} 0`}>
                  <Checkbox checked={filter.teams.includes(item)} aria-label={`Select team ${item}`}></Checkbox>
                  <Ellipsis tooltip={true}>{item}</Ellipsis>
                </Stack>
              </Select.Option>
            )}
            onChange={(values) =>
              setFilter((draft) => {
                draft.teams = values;
              })
            }
          />

          <Button
            variant='secondaryGray'
            onClick={() => setFilter(initialFilter)}
            data-test-id='template-filter-reset-filters-button'>
            Reset filters
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
